module.exports = __webpack_public_path__ + "static/media/check_off.ef0d4ed4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check_off.svg
// module id = 161
// module chunks = 0